import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import Config from "../models/Config";
import Species from "./Species";

export default function SpeciesMenu(props) {
  const { showSpecies, setShowSpecies } = props;

  if (showSpecies) {
    return (
      <div className="text-center">
        <div className="text-center mb-8" style={{ minHeight: "40px" }}>
          <button
            onClick={() => setShowSpecies(false)}
            class="rounded-md bg-gray-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-600 active:bg-gray-700"
          >
            <ChevronUpIcon className="h-5 w-5 float-left mr-1"></ChevronUpIcon>{" "}
            Hide
          </button>
        </div>
        {
        Object.keys(Config).map((item, i) => {
          return (<Species type={Config[item]}></Species>);
        })}
        <button class="inline-block px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-gray-300 shadow-md hover:bg-opacity-75 mr-5 ml-5 cursor-pointer mb-5">Antirrhinum majus</button>
        <button class="inline-block px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-gray-300 shadow-md hover:bg-opacity-75 mr-5 ml-5 cursor-pointer mb-5">Chlamydomonas reinhardtii</button>
        <button class="inline-block px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-gray-300 shadow-md hover:bg-opacity-75 mr-5 ml-5 cursor-pointer mb-5">Fragaria sp.</button>
        <button class="inline-block px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-gray-300 shadow-md hover:bg-opacity-75 mr-5 ml-5 cursor-pointer mb-5">Prunus persica</button>
      </div>
    );
  } else {
    return (
      <div className="text-center" style={{ minHeight: "40px" }}>
        <button
          onClick={() => setShowSpecies(true)}
          class="rounded-md bg-gray-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-600 active:bg-gray-700"
        >
          <ChevronDownIcon className="h-5 w-5 float-left mr-1"></ChevronDownIcon>{" "}
          Show all species
        </button>
      </div>
    );
  }
}
